var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleOriginal = function SvgGoogleOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M19 10.215c0-.664-.06-1.3-.17-1.912h-8.803v3.615h5.03a4.3 4.3 0 0 1-1.865 2.82v2.347h3.02C17.98 15.457 19 13.06 19 10.215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M10.027 19.349c2.524 0 4.64-.837 6.186-2.264l-3.02-2.346c-.838.56-1.908.893-3.166.893-2.434 0-4.495-1.645-5.23-3.854H1.674V14.2a9.34 9.34 0 0 0 8.353 5.149"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M4.797 11.778a5.6 5.6 0 0 1-.293-1.776c0-.616.106-1.215.293-1.776V5.804H1.674a9.352 9.352 0 0 0 0 8.396z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M10.027 4.373c1.372 0 2.605.472 3.573 1.397l2.681-2.68C14.662 1.58 12.547.655 10.027.655a9.34 9.34 0 0 0-8.353 5.15l3.123 2.421c.735-2.209 2.796-3.853 5.23-3.853"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleOriginal);
export { ForwardRef as ReactComponent };